import { useState } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { stages } from "@/mocks/content";

export default function StagesSection() {
  const [active, setActive] = useState(stages[0].key);
  const current = stages.find((s) => s.key === active) ?? stages[0];

  return (
    <section id="stages" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-6 md:px-8">
        <SectionHeading
          eyebrow="恋爱阶段"
          title="你现在，处在关系的哪一段？"
          desc="同一句建议，放在不同阶段就会有不同的答案。先找到自己的位置，再看该做什么。"
          align="center"
        />

        <div className="mt-8 flex flex-wrap justify-center gap-2">
          {stages.map((stage) => {
            const isActive = stage.key === active;
            return (
              <button
                key={stage.key}
                type="button"
                onClick={() => setActive(stage.key)}
                className={`rounded-full px-4 py-2 font-label text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  isActive
                    ? "bg-primary-500 text-background-50"
                    : "border border-background-300 bg-background-100 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
                }`}
                aria-pressed={isActive}
              >
                {stage.label}
              </button>
            );
          })}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:col-span-2 md:p-7">
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 font-label text-xs text-secondary-900">
              <i className="ri-map-pin-2-line"></i>
              {current.label}
            </span>
            <p className="mt-4 font-heading text-lg font-semibold text-foreground-950">{current.situation}</p>

            <h3 className="mt-6 font-label text-sm font-medium text-foreground-900">这个阶段可以做的事</h3>
            <ul className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-3">
              {current.actions.map((action, i) => (
                <li key={action} className="rounded-md border border-background-200 bg-background-50 p-3">
                  <span className="font-label text-xs text-accent-700">0{i + 1}</span>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-700">{action}</p>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-5">
            <div className="rounded-lg border border-background-200 bg-accent-50 p-5">
              <div className="flex items-center gap-2 text-accent-700">
                <i className="ri-question-line"></i>
                <span className="font-label text-xs">常见的困扰</span>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-800">{current.worry}</p>
            </div>
            <div className="flex-1 rounded-lg border border-background-200 bg-background-100 p-5">
              <div className="flex items-center gap-2 text-primary-600">
                <i className="ri-lightbulb-flash-line"></i>
                <span className="font-label text-xs">一些小建议</span>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">{current.advice}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}